
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { EditFormInterface } from '@/types/interfaces/EditResource/EditFormInterface';
import { ApiResource } from '@/types/resources/ApiResource';
import { ImageObject } from '@/types/resources/ImageObject';

@Component({
  components: { ValidationProvider },
})
export default class ImageObjectEditForm extends Vue implements EditFormInterface {
  @Prop({ type: Object, required: true }) resource!: ImageObject;

  $refs!: {
    imagePreview: HTMLImageElement;
  }

  private file: File | null = null;

  private caption = '';

  get filename() {
    if (this.file instanceof File) {
      return this.file.name;
    }
    if (this.resource?.filename) {
      return this.resource.filename;
    }

    return '';
  }

  get filesize() {
    if (this.file instanceof File) {
      if (this.file.size > 999999) {
        return `${(this.file.size / 1000000).toFixed(2)} MB`;
      }

      return `${Math.ceil(this.file.size / 1000)} KB`;
    }

    return '';
  }

  loadLocalResource(): void {
    this.caption = this.resource.caption;
  }

  prepareLocalResource(): Partial<ApiResource> | FormData | null {
    const form = new FormData();
    form.append('caption', this.caption);
    if (this.file !== null) {
      form.append('file', this.file);
    }

    return form;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resetLocalResource(): void {
    this.file = null;
    this.caption = this.resource.caption;
  }

  @Watch('file')
  updatePreview(newValue: File) {
    this.$refs.imagePreview.src = URL.createObjectURL(newValue);
    this.$refs.imagePreview.onload = () => {
      URL.revokeObjectURL(this.$refs.imagePreview.src); // free memory
    };
  }
}
